import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Photos from '../components/Photos';
import Videos from '../components/Videos';

const styles = theme => ({
  root: {
    marginTop: 10,
    padding: 20
  }
});

class Media extends Component {

  state = {
    current: 0
  };

  change = (evt, val) => {
    this.setState({
      current: val
    });
  }

  render() {
    const { classes } = this.props;
    const { current } = this.state;
    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} sm={8}>
            <Tabs
              variant="fullWidth"
              value={current}
              onChange={this.change}
            >
              <Tab label="PHOTOS" />
              <Tab label="VIDEOS" />
            </Tabs>
            {current === 0 && <Photos />}
            {current === 1 && <Videos />}
          </Grid>
        </Grid>
      </div>
    )
  }
}

Media.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Media);


